// extracted by mini-css-extract-plugin
export var container = "pageWelcome-module--container--emKWe";
export var theme = "pageWelcome-module--theme--xEyjz";
export var icon1Img = "pageWelcome-module--icon1Img--nYh0b";
export var icon2Img = "pageWelcome-module--icon2Img--uiJU1";
export var icon3Img = "pageWelcome-module--icon3Img--Q2XX9";
export var icon4Img = "pageWelcome-module--icon4Img--3MkLa";
export var icon5Img = "pageWelcome-module--icon5Img--FmaKG";
export var icon6Img = "pageWelcome-module--icon6Img--2wnlU";
export var icon7Img = "pageWelcome-module--icon7Img--dVu7e";
export var title = "pageWelcome-module--title--ONfOK";
export var startButton = "pageWelcome-module--startButton--XCk2o";